import { render } from "./RecordDetails.vue?vue&type=template&id=a2745644&scoped=true"
import script from "./RecordDetails.vue?vue&type=script&lang=js"
export * from "./RecordDetails.vue?vue&type=script&lang=js"

import "./RecordDetails.vue?vue&type=style&index=0&id=a2745644&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2745644"]])

export default __exports__